import { Button, IStyleConfig } from '@cian/components';
import * as React from 'react';

export interface IButtonCheckboxProps {
  children?: React.ReactNode;
  onValueChange(value: boolean): void;
  value: boolean;
  buttonStyle?: IStyleConfig;
}

export class ButtonCheckbox extends React.Component<IButtonCheckboxProps> {
  public render() {
    const theme = this.props.value ? 'button/toggleActive' : 'button/toggle';

    return (
      <Button buttonStyle={this.props.buttonStyle} theme={theme} onClick={this.handleClick}>
        {this.props.children}
      </Button>
    );
  }

  private handleClick = () => {
    this.props.onValueChange(!this.props.value);
  };
}
